import store from 'src/vuex/index';
import { fetch } from 'utils/fetch';
import Vue from 'vue';
import applyMap from '../datas/apply/applyMap.json';
import axios from 'axios';
import { getQueryString } from '../utils/environment';
import config from 'config';
import { hlyRouter } from 'utils/routerTools';
import LoginBindService from 'api/login-bind';

let applicationMap = applyMap.applicationMap;

// 获取停机或者运维公告
export function maintenanceAnnounce(url, params) {
  // let params = {
  //     domain,
  //     clientCode
  // }
  return axios({
    url,
    method: 'GET',
    params,
  });
}

export function getStopAnnounceAfterLogin(params) {
  return fetch({
    url: '/operationservice/public/search/maintenanceAnnounce',
    method: 'GET',
    params,
  });
}

export function getMultiLanguageHash() {
  return fetch({
    url: '/operationservice/public/multilanguage/release',
    method: 'GET',
    params: {
      environment: config.env === 'prod' ? 'prod' : 'stage',
      client: 'app_wechat',
    },
  });
}

export function getCustomizeLanguage(language, tenantId) {
  return fetch({
    url: '/operationservice/public/system/custom/copy/search',
    method: 'GET',
    params: {
      client: 'app',
      tenantId,
      language,
    },
  });
}

export function getQuestionnaire(params) {
  return fetch({
    url: '/operationservice/public/search/maintenanceAnnounce/Questionnaire',
    method: 'GET',
    params,
  });
}

export function noMoreShowQuestionnaire(params) {
  return fetch({
    url: '/operationservice/public/questionnaire/delivery/show/delivery',
    method: 'POST',
    params,
  });
}

// 判断用户是否是白名单用户，停机（恢复）时可以进入
export function getIsWhiteList(params) {
  return axios({
    url: '/operationservice/public/isWhitelist',
    method: 'GET',
    params: params,
  });
}

export function getCostCenterItemDetail(costCenterItemOID) {
  return fetch({
    url: '/api/cost/center/item/' + costCenterItemOID,
    method: 'GET',
  });
}

export function getCostCenterItemAll(costCenterOID, page, size) {
  return fetch({
    url: '/api/cost/center/items/' + costCenterOID + '/all',
    method: 'GET',
    params: {
      page: page,
      size: size,
    },
  });
}

// 编辑申请单 获取申请单信息
export function getCustFormList(formType, applicationOID) {
  return fetch({
    url: applicationMap[formType].apiPath + applicationOID,
    method: 'GET',
  });
}

// 新建申请单
export function createCustFormList(formOID) {
  return fetch({
    url: '/api/custom/forms/' + formOID,
  });
}

// 获取所有申请单
export function getApplicationListByStatus({ status, page = 0, size = 10 }) {
  return fetch({
    url: '/api/applications/all',
    params: {
      status: status,
      page: page,
      size: size,
    },
  });
}

//获取指定公司信息
export function getCompany(companyOID) {
  return fetch({
    url: '/api/companies/noAuthorities/' + companyOID,
    method: 'GET',
  });
}

// 获取部门信息
export function getDepartmentDetail(departmentOID) {
  return fetch({
    url: '/api/departments/' + departmentOID,
    method: 'GET',
  });
}

// 获取人员信息
export function getUserDetail(userOID) {
  return fetch({
    url: '/api/users/oids?userOIDs=' + userOID,
    method: 'GET',
  });
}

// 获取法人代表信息
export function getCorporationDetail(value) {
  return fetch({
    url: '/api/my/company/receipted/invoice/' + value,
    method: 'GET',
  });
}

// 获取供应商信息
export function getSupplierDetail(isNewTravel) {
  let params = isNewTravel
    ? {}
    : {
        category: 2001,
      };
  return fetch({
    url: '/api/suppliers',
    method: 'GET',
    params,
  });
}

// 获取银行账号

export const getBankAccount = (page, size, userOID) =>
  fetch({
    url: '/api/contact/bank/account/enable',
    method: 'GET',
    params: {
      page: page,
      size: size,
      userOID: userOID,
    },
  });

// 获取公司下管理员
export const getAdminList = (page, size, companyOID) =>
  fetch({
    url: '/api/account/get/admin/' + companyOID,
    method: 'GET',
    params: {
      page: page,
      size: size,
    },
  });

// 获取默认借款申请单
export const getDefaultLoanApplication = (applicationOID, applicantOID) =>
  fetch({
    url: '/api/loanBill/applicant/default',
    method: 'GET',
    params: {
      applicationOID: applicationOID,
      applicantOID: applicantOID,
    },
  });

// 获取个人借款申请详情
export const getLoanApplicationDetail = (applicationOID) =>
  fetch({
    url: '/api/loan/application/' + applicationOID,
    method: 'GET',
  });

export const getBankItem = (bankNO) =>
  fetch({
    url: '/api/contact/bank/account/' + bankNO,
    method: 'GET',
  });

// 根据币种和时间获取汇率

export const getItemCurrency = (currency, currencyDate, userOID, setOfBookId) =>
  fetch({
    url: '/api/company/standard/currency/get',
    method: 'get',
    params: {
      currency,
      currencyDate,
      userOID,
      setOfBookId,
    },
  });

export const getMobileCode = (mobile, version) => {
  let url = '/api/refactor/activation/mobile/token';
  if (version == 'old') {
    url = '/api/activation/token';
  }
  return fetch({
    url: url,
    method: 'get',
    params: {
      mobile,
    },
  });
};

export const getEmailCode = (email, version) => {
  if (version == 'old') {
    return getMobileCode(email, version);
  }
  return fetch({
    url: '/api/refactor/activation/email/token',
    method: 'get',
    params: {
      email,
    },
  });
};

export const checkValidate = (mobile, token) =>
  fetch({
    url: '/api/activation/check',
    method: 'post',
    params: {
      mobile,
      token,
    },
  });

export function checkMobileValidate(params) {
  let url = '/api/refactor/activation/mobile/check';
  return fetch({
    url: url,
    method: 'post',
    params: params,
  });
}

export const checkEmailValidate = (email, token, version) => {
  if (version == 'old') {
    return checkValidate(email, token);
  }
  return fetch({
    url: '/api/refactor/activation/email/check',
    method: 'POST',
    headers: {
      'Content-Type': 'application/form-data',
    },
    params: {
      email,
      token,
    },
  });
};

//获取密码校验规则
export function getTokencheckRule(username) {
  return fetch({
    url: '/api/refactor/password/rule/topic',
    method: 'GET',
    params: {
      username,
    },
  });
}

export function setPassword(mobile, token, password) {
  return fetch({
    url: '/api/activate',
    method: 'get',
    params: { mobile, token, password },
  });
}

export function MobileSetpassword(mobile, token, newpassword, version) {
  if (version == 'old') {
    return setPassword(mobile, token, newpassword);
  }

  return fetch({
    url: '/api/refactor/activate/mobile',
    method: 'post',
    headers: {
      'Content-Type': 'application/form-data',
    },
    params: {
      mobile: mobile,
      token: token,
      newPassword: newpassword,
    },
  });
}

export function EmailSetpassword(email, token, newpassword, version) {
  if (version == 'old') {
    return setPassword(email, token, newpassword);
  } else
    return fetch({
      url: '/api/refactor/activate/email',
      method: 'post',
      headers: {
        'Content-Type': 'application/form-data',
      },
      params: {
        email: email,
        token: token,
        newPassword: newpassword,
      },
    });
}

export const getcorporation = (corporationOID) =>
  fetch({
    url: '/api/my/company/receipted/invoice/' + corporationOID,
    method: 'GET',
  });

export const getLocation = (code) =>
  fetch({
    url: '/location-service/api/locations/' + code,
    method: 'GET',
    headers: {
      language: 'zh_cn',
    },
  });

export const getCtripprompts = (userOID) =>
  fetch({
    url: '/ctrip/api/ctrip/company/config/get/prompts',
    method: 'GET',
    params: {
      userOID,
    },
  });

export const getSecretary = (params) =>
  fetch({
    url: '/vendor-info-service/api/sso/lnglat',
    method: 'POST',
    data: params,
  });

export const getWebAppSSO = (params, headers) => {
  return fetch({
    url: '/auth/oauth/token',
    method: 'POST',
    params: params,
    headers: headers,
  });
};

export const getUserTokenMultipleCloud = (params, headers) => {
  let url = '/proxy/oauth/token';
  return fetch({
    url: url,
    method: 'POST',
    params: params,
    headers: headers,
  });
};

export const getUserToken = (params, headers, useAuthService) => {
  /*let form = new FormData();
  for(let key in params){
      form.append(key, params[key]);
  }*/
  //钉钉自建应用唯一标识
  let appKey = getQueryString('appKey');
  if (appKey) {
    params.appKey = appKey;
  }
  let url = '/oauth/token';
  if (useAuthService) {
    url = '/auth/oauth/token';
  }
  const tenantId = sessionStorage.getItem('hly.multi-tenantId');
  if (tenantId) {
    params.tenant_id = tenantId;
  }
  return fetch({
    url: url,
    method: 'POST',
    params: params,
    headers: headers,
  });
};

export const getUserCorpId = (params) => {
  return new Promise((resolve, reject) => {
    fetch({
      url: '/wechat-service/feishu/public/api/user/bind/find/fsAccount/by/code/and/appId',
      method: 'GET',
      params: params,
    })
      .then((res) => {
        resolve(res);
        const { data: { data: { tenantOpening = false } = {} } = {} } = res;
        if (tenantOpening) {
          reject();
          /*
          hlyRouter.replace({
            name: 'invalid-auth',
            params: { errorMessage: window.$t('global-1.key266', { cm: '资源开通中' }), businessType: 'sso-error' },
          });
          */
        } else {
          resolve(res);
        }
      })
      .catch((err) => {
        reject(err);
      });
  });
};

// 获取钉钉开户标识
export const checkDingtalkTenantOpening = (params) => {
  return fetch({
    url: '/dingtalk/common/check/opening/tenant',
    method: 'GET',
    params: params,
  });
};

export const getYZJCorpId = (params) => {
  return fetch({
    url: '/wechat-service/yzj/public/api/user/bind/find/yzjAccount/by/code/and/appId',
    method: 'GET',
    params: params,
  });
};

// 这个接口会被删掉
export const getMenus = () =>
  fetch({
    url: '/api/personalized/menus',
    method: 'GET',
  });

export const getddConfig = (params) =>
  fetch({
    url: '/dingtalk/common/get/jsticket/sign',
    method: 'POST',
    data: params,
  });

// account接口报错通用处理（H5绑定登录场景）
export const checkAccountErr = (err) => {
  const { errorCode } = (err && err.response && err.response.data) || {};
  // message && Vue.$handPlugin.toast.show(message);
  // 当前账号需要进行安全验证，通过验证后才可以登录
  // 触发解绑 重新回到登录页
  if (errorCode === 'inf-89875@20230616001') {
    let loginType = getQueryString('loginType');
    let isTrial = getQueryString('isTrial');
    let map = {
      feishu: { clientType: 'feishu' },
      yzj: { clientType: 'yzj' },
      dd: { clientType: 'dingTalk' },
      wxmp: { clientType: 'wxserviceaccount' },
      wx: { clientType: 'wechat' },
      welink: { clientType: 'welink' },
    };
    let params = map[loginType] || { clientType: 'wxserviceaccount' };
    if (isTrial === 'Y') {
      params.isTrial = true;
    }
    LoginBindService.unbindWeChatService(params).then((res) => {
      if (res.status === 200) {
        // 解绑时清除guide缓存
        window.localStorage.removeItem('hlyV2HideRefactorMainGuide');
        window.localStorage.removeItem('hlyV2HideApplicationManageGuide');
        window.localStorage.removeItem('hlyV2Token');
        store.commit('storeToken', {});
        if (isTrial === 'Y') {
          hlyRouter.replace({ name: 'trialLogin' });
        } else {
          hlyRouter.replace({ name: 'accountLogin' });
        }
      }
    });
  }
};

export const getAccount = () =>
  fetch({
    url: '/auth/api/account',
    method: 'GET',
  }).catch((err) => {
    checkAccountErr(err);
    throw err;
  });

// 新版获取配置信息
export const getConfigOptions = (userOID) => {
  return fetch({
    url: '/api/options',
    method: 'GET',
    params: {
      userOID,
    },
  });
};

// 开启应用角标提醒时 补偿角标同步
export const getFeishuAppBadge = () => {
  return fetch({
    url: '/api/app/badge/sync',
    method: 'POST',
  });
};

export const getProfile = () => {
  return fetch({
    url: '/api/function/profiles',
    method: 'GET',
  });
};

export const getCompanyConfig = () =>
  fetch({
    url: '/api/dept/company/config',
    method: 'GET',
  });

// 获取用户在公司中的配置，主要用configuration中的integrations字段
export const getCompanyUserConfig = () =>
  fetch({
    url: '/api/company/configurations/user',
    method: 'GET',
  });

export const postDdImg = (params) =>
  fetch({
    url: '/api/dingtalk/upload/attachments',
    method: 'POST',
    data: params,
  });

export const postWxImg = (params) => {
  if (getQueryString('loginType') === 'wxmp') {
    params.corpId =
      window.location.href.indexOf('appcoreuat.huilianyi.com') > -1 ? 'wx18390b267b7c7f11' : 'wx2103ff773e82edda';
    params.tokenType = 'FWTOKEN';
  }
  if (getQueryString('loginType') === 'wx' && getQueryString('agentId')) {
    params.agentId = getQueryString('agentId'); //企业微信拆子应用
  }
  return fetch({
    url: '/api/wechat/upload/wxattachment',
    method: 'POST',
    data: params,
  });
};

export const postDdHead = (params) =>
  fetch({
    url: '/api/dingtalk/upload/head/portrait',
    method: 'POST',
    data: params,
  });

export const postWxHead = (params) =>
  fetch({
    url: '/api/wechat/contact/add/wxheadPortrait',
    method: 'POST',
    data: params,
  });

export const ddBindPhone = (params) =>
  fetch({
    url: '/dingtalk/common/save/user/mapping',
    method: 'POST',
    params: params,
  });

export const getddMobileCode = (params) =>
  fetch({
    url: '/dingtalk/common/send/mobile/validation/code',
    method: 'GET',
    params: params,
  });

export const getddEmailCode = (params) =>
  fetch({
    url: '/api/refactor/dingtalk/email/token',
    method: 'GET',
    params: params,
  });

export const getCustomValueItemDetail = (dataFrom, customEnumerationOID, messageKey) => {
  //dataFrom  102  外部值列表
  if (dataFrom === 102) {
    return fetch({
      url: '/api/custom/enumerations/items/out',
      method: 'GET',
      params: {
        customEnumerationOID,
        messageKey,
      },
    });
  } else {
    return fetch({
      url: '/api/custom/enumerations/items',
      method: 'GET',
      params: {
        customEnumerationOID,
        messageKey,
      },
    });
  }
};

export const searchCustomValue = (dataFrom, customEnumerationOID, params) => {
  if (dataFrom === 101) {
    return fetch({
      url: '/api/custom/enumerations/' + customEnumerationOID + '/items/by/user',
      method: 'GET',
      params: params,
    });
  } else {
    return fetch({
      url: '/api/custom/enumerations/' + customEnumerationOID + '/items/out',
      method: 'GET',
      params,
    });
  }
};

export const ctripCard = () =>
  fetch({
    url: '/api/ctrip/open/card',
    method: 'POST',
  });

export const getInvoiceDetail = (data) =>
  fetch({
    url: '/receipt/api/receipt/wx/detail/v2',
    method: 'POST',
    data: data,
  });

export const getInvoicePDF = (id) =>
  fetch({
    url: '/receipt/api/receipt/pdf/' + id,
    method: 'GET',
  });

export const getCardSign = (cardsignType) => {
  let timestamp = parseInt(new Date().getTime() / 1000); //需要以秒为单位
  let params = {
    timestamp: timestamp,
    type: cardsignType ? cardsignType : 'JSCARDSIGN', //APPCARDSIGN/JSCARDSIGN,对应appID：wxacfd8b05dc448523(APP)/wxab06537b97cdf28a(微信)
    companyOID: store.getters.getMyInfo.companyOID,
  };

  if (getQueryString('loginType') === 'wx' && getQueryString('agentId')) {
    params.agentId = getQueryString('agentId'); //企业微信拆子应用
  }

  return fetch({
    url: '/api/getCardSign/v2',
    method: 'POST',
    data: params,
  })
    .then((response) => response.data)
    .catch((error) => {
      Vue.$handPlugin.toast.show('获取CardSign失败，请联系管理员');
    });
};

export const getApplicationDraft = (entityOid, entityType) => {
  return fetch({
    url: '/api/document',
    method: 'GET',
    params: {
      entityOid,
      entityType,
    },
  });
};

export const getWeLinkSignature = (nowUrl) => {
  return fetch({
    url: '/wechat-service/welink/public/signature',
    method: 'GET',
    params: { url: nowUrl },
  });
};

export const getWeLinkAppId = () => {
  return fetch({
    url: '/wechat-service/welink/public/app/config',
    method: 'GET',
  });
};
export const getDdTrialCorpId = () => {
  return fetch({
    url: '/api',
    method: 'GET',
  });
};
// 获取元数据对象值
export const getRelationFieldData = (params) => {
  return fetch({
    url: 'api/obj/tmp/filed/value/get/data',
    method: 'POST',
    data: params,
  });
};
// 获取超链接控件-多选值列表跳转链接
export const getHyperlinkMoreCustList = (params) => {
  return fetch({
    url: '/api/custom/forms/link',
    method: 'GET',
    params,
    nativeResponseSerializer: 'boolean',
  });
};
// 超链接回调模式跳转
export const goHyperlinkCallback = (params) => {
  return fetch({
    url: '/api/custom/forms/link/callback',
    method: 'POST',
    data: params,
    nativeResponseSerializer: 'boolean',
  });
};
// 钉钉消息转发
export const handleDDMsgForward = (params) => {
  return fetch({
    //去掉v1 钉钉云需要配置下 notification 的转发
    //url: (params.platform === 'DING_DING' ? '/v1' : '') + '/notification/api/notification/bill/approving/msg/forward',
    url: '/notification/api/notification/bill/approving/msg/forward',
    method: 'PUT',
    data: params,
  });
};

export const getEnumerationList = (params) => {
  return fetch({
    url: '/api/custom/enumeration/items/by/template/type',
    method: 'GET',
    params: params,
  });
};

// 获取企业微信同步标识
export const getWechatSourceTag = (params) => {
  return fetch({
    url: '/wechat-service/wechat/public/wxCorpInfo',
    method: 'get',
    params,
  });
};

// 获取钉钉组织架构同步标识
export const getDingTalkTenantType = (params) => {
  if (!params.corpId || !params.appKey) {
    return Promise.resolve({ data: {} });
  }
  return fetch({
    url: '/dingtalk/common/get/internal/app/auth/config',
    method: 'get',
    params,
  });
};

export const printLogToServer = (params) => {
  return fetch({
    url: '/api/test/common/print/log',
    method: 'POST',
    data: params,
    nativeResponseSerializer: 'boolean',
  });
};

export const recordDownloadInfo = (params) => {
  return fetch({
    url: '/api/common/download/record',
    method: 'get',
    params: { attachmentOID: params && params.attachmentOID },
  });
};

/**
 * 附件下载/打印获取水印文件接口
 * @param attachmentOIDS
 * @return {*|Promise<unknown>}
 */
export const getAttachmentDownloadWaterMark = ({ attachmentOIDS }) => {
  return fetch({
    url: '/api/attachment/download/watermark',
    method: 'post',
    data: {
      attachmentOIDS: attachmentOIDS,
    },
  });
};
